<template>
  <div class="w-full">
    <div v-if="false">
      <p>source2: {{ source2 }}</p>
      <p>valueFile: {{ valueFile }}</p>
      <p>value : {{ value }}</p>
      <p>config : {{ config }}</p>
      <p>isActive : {{ isActive }}</p>
      <p>debug : {{ debug }}</p>
    </div>

  <div class="relative mt-2 mb-2 w-full" v-if="source2 == undefined || source2.length == 0"  >
      <nav class="border-gray-200 px-4 lg:px-6 py-2.5  justify-between flex flex-row items-center">
        <div id="mobile-menu-2" class="justify-between items-center w-full lg:flex lg:w-auto lg:order-1">
          <ul class="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0 justify-end w-full">
            <li>
              <a
                v-if=" !(config?.buttons?.generate == false)"
                href="#"
                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold"
                aria-current="page"
                @click="onGenerate()"
              >
                <i class="fa-brands fa-creative-commons-share" /> Générer</a
              >
            </li>
          </ul>
        </div>
        </nav>
        </div>

    <div class="relative mt-2 mb-2 w-full" v-for="pdf in source2" :key="pdf.id">
      <nav class="border-gray-200 px-4 lg:px-6 py-2.5  justify-between flex flex-row items-center">
        <div id="mobile-menu-2" class="justify-between items-center w-full lg:flex lg:w-auto lg:order-1">
          <ul class="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0 justify-end w-full">
            <li>
              <a
                v-if=" !(config?.buttons?.generate == false)"
                href="#"
                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold"
                aria-current="page"
                @click="onGenerate()"
              >
                <i class="fa-brands fa-creative-commons-share" /> Générer</a
              >
            </li>
          </ul>
        </div>

        <div class="justify-between items-center w-full lg:flex lg:w-auto lg:order-1" id="mobile-menu-2" v-if="!isLoading">
          <ul class="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0 justify-end w-full">
            <li v-if="!(config?.buttons?.refresh == false)" class="hidden">
              <a
                href="#"
                @click="onRefresh(pdf)"
                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold"
                aria-current="page"
                ><i class="fa-solid fa-arrows-rotate"></i> Rafraîchir
              </a>
            </li>
            <li v-if="pdf.id != '' && !(config?.buttons?.download == false)">
              <a
                href="#"
                @click="onDownload(pdf)"
                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold"
                aria-current="page"
                ><i class="fa-solid fa-download mr-1"></i> Télécharger
              </a>
            </li>
            <li v-if="pdf.id != '' && !(config?.buttons?.print == false)" class="hidden">
              <a
                href="#"
                @click="printPDF(pdf)"
                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold"
              >
                <i class="fa-solid fa-print mr-1"></i> Imprimer</a
              >
            </li>
            <li v-if="pdf.id != '' && !(config?.buttons?.email == false)">
              <a
                href="#"
                @click="onResend(pdf)"
                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold"
              >
                <i class="fa-solid fa-share mr-1"></i> Renvoyer</a
              >
            </li>
          </ul>
        </div>
      </nav>

      <div class="min-h-96">
        <vue-pdf-embed
          :ref="(el) => storePdfRef(el, pdf.id)"
          :id="`pdf-${pdf.id}`"
          class="w-full"
          :source="pdf.url"
          :data-pdf-ref="`pdf-${pdf.id}`"
          @loaded="handleDocumentLoad"
          v-if="pdf.id != ''"
          @rendered="handleDocumentRender"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import service from "@/services/FullService.vue"
import { mapGetters } from "vuex";
import VuePdfEmbed from "vue-pdf-embed";

export default {
  name: "ContentPDF",
  components: {
    VuePdfEmbed,
  },
  props: {
    id: String,
    label: String,
    placeholder: String,
    required: Boolean,
    value: [String,Array],
    valueFile: [String, Array],
    record: Object,
    isActive: Boolean,
    currentTab: Number,
    indexTab: Number,
    config: Object,
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    mapRef: function (a) {
      if (a == undefined) return null;
      return a;
    },
    showButtons() {
      // if (this.$route.params.id == "inbound-invoices") return false
      return true;
    },
  },

  data() {
    return {
      pdfRefs: {},
      source2: [],
      source3: "",
      output: "",
      debug: [],
      isLoading: true,
      page: null,
      pageCount: null,
      c: 0,
    };
  },
  watch: {
    isActive: async function (val) {
      if (this.value == undefined) {
        this.isLoading = false;
        this.source2 = [];
        return;
      }

    
      let path = "files";
      this.debug.push("isActive 1 -" + val);
      if (this.config.path) path = this.config.path;

      if (val == true) {
        this.debug.push("f (val == true) 1");
        if (Array.isArray(this.value)) {
          let ar = [];
          for (let i = 0; i < this.value.length; i++)
            ar.push({
              id: this.value[i],
              url: "https://files.b4food.io/b4food/" + path + "/" + this.value[i],
            });

          this.source2 = ar;
        } else {
          let ar = [];
          ar.push({
            id: this.value,
            url: "https://files.b4food.io/b4food/" + path + "/" + this.value,
          });
          this.source2 = ar;
        }

        // //  this.source2 = "https://files.b4food.io/b4food/files/" + this.value

        // this.source2 = "https://files.b4food.io/b4food/images/" + this.value[0]

        //let ar = [];
        //for (let i = 0; i < this.value.length; i++) ar.push("https://files.b4food.io/b4food/images/" + this.value[i])
        //  this.source2 = "https://files.b4food.io/b4food/files/" + this.value
        //   this.source2 = ar
      } else {
        this.debug.push("f (val == false) 1");
        this.source2 = [];
      }
    },
    currentTab: async function (/*val*/) {
      
    },

    indexTab: async function (/*val*/) {
   
    },

    value: async function (val) {
      this.output = val;

      if (val == undefined) {
        this.isLoading = false;
        return;
      }

      if (this.value != undefined) {
        this.c++;
      }
    },
  },

  async mounted() {
    this.output = this.value;
    if (this.value != undefined) {
      //  let pdf = await service.getDataId("files/base64", this.value, this.user?.token, { fields: 'id,name, data' })

      this.source3 = "https://files.b4food.io/b4food/files/" + this.value;

      this.loadPdf(true);
    }

    /*
                        this.$nextTick(function () {
                            window.scrollTo(0, 0)
                        }); */
  },
  methods: {
    storePdfRef(el, id) {
 

      if (el) {
        this.pdfRefs[id] = el;
      }
      //   if (el) {
      //       this.pdfRefs = { ...this.pdfRefs, [id]: el }; // Ajoute ou met à jour la référence
      //   }

      //  else {
      //      const { [id]: removed, ...rest } = this.pdfRefs; // Supprime la référence si nécessaire
      //      this.pdfRefs = rest;
      //  }
    },

    loadPdf(val) {
    
      let path = "files";
      this.debug.push("isActive 1 -" + val);
      if (this.config.path) path = this.config.path;

      if (val == true) {
        this.debug.push("f (val == true) 1");
        if (Array.isArray(this.value)) {
          let ar = [];
          for (let i = 0; i < this.value.length; i++)
            ar.push({
              id: this.value[i],
              url: "https://files.b4food.io/b4food/" + path + "/" + this.value + "?date=" + Date.now(),
            });

          this.source2 = ar;
        } else {
          let ar = [];
          ar.push({
            id: this.value,
            url: "https://files.b4food.io/b4food/" + path + "/" + this.value + "?date=" + Date.now(),
          });
          this.source2 = ar;
        }

        // //  this.source2 = "https://files.b4food.io/b4food/files/" + this.value

        // this.source2 = "https://files.b4food.io/b4food/images/" + this.value[0]

        //let ar = [];
        //for (let i = 0; i < this.value.length; i++) ar.push("https://files.b4food.io/b4food/images/" + this.value[i])
        //  this.source2 = "https://files.b4food.io/b4food/files/" + this.value
        //   this.source2 = ar
      } else {
        this.debug.push("f (val == false) 1");
        this.source2 = [];
      }
    },

    handleDocumentRender() {
  
      this.isLoading = false;
    },
    handleDocumentLoad(numPages) {
     

      this.pageCount = numPages.numPages;
    },
    onDownload: function (pdf) {
      let name = "download.pdf";
      if (this.record.pdf_file_name) name = this.record.pdf_file_name;

      let id = "pdf-" + pdf.id;

      if (this.pdfRefs[pdf.id]) {
        this.pdfRefs[pdf.id].download(name); // Appelle la méthode download de l'instance
      } else {
        console.error(`PDF with ID ${id} not found.`);
      }
    },
    onGenerate: function () {
     
      if (this.config.action == undefined) {
        window.location.reload();
        return;
      }
  
      this.$emit("action", {
        type: this.config.action,
        id: this.record._id,

        collection: this.$route.params.id,
      });
    },
    onRefresh: function () {
      this.source2 = "";

      if (this.value == undefined) {
        window.location.reload();
        return;
      }

      setTimeout(() => {
    
        this.source2 = "https://files.b4food.io/b4food/files/" + this.value;
      }, 200);

      // this.$emit("action", { type: this.config.action, id: this.record._id, collection: this.$route.params.id})
    },
    onResend: function () {
      this.$emit("action", {
        type: this.config.action_mail ? this.config.action_mail : "send-mail",
        id: this.record._id,

        collection: this.$route.params.id,
      });
    },

    printPDF: function (pdf) {
      if (this.$refs["pdf-" + pdf.id]) {
        this.$refs["pdf-" + pdf.id].print();
      }
    },
    downloadPDF: function (base64, filename) {
      // Create an anchor element

      var link = document.createElement("a");
      link.href = base64;
      link.download = filename;
      document.body.appendChild(link);
      // Click the link
      link.click();
      // Remove the link
      document.body.removeChild(link);
    },

    OnView: function (v) {
      this.viewBy = v;

      this.$nextTick(() => {
        if (v == 2) {
          this.$refs.pdfRef1.render();
          this.$refs.pdfRef2.render();
        }
      });
    },

    getData() {},
  },
};
</script>

<style>
.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.vue-pdf-embed > div > div > canvas {
  min-height: 400px;
  width: 700px;
}
</style>
